import checkout from "./form";

const {
  formField: { taxId, conpanyName, releaseDate, representative, creator, method, date, sendTo },
} = checkout;

const initialValues = {
  [taxId.name]: "",
  [conpanyName.name]: "",
  [releaseDate.name]: "",
  [representative.name]: "",
  [creator.name]: "",
  [method.name]: "",
  [date.name]: "",
  [sendTo.name]: "",
};

export default initialValues;
